import { KEY_REDUCER_SETTINGS } from "./constants";

export const selectorSettings = (state) => state[KEY_REDUCER_SETTINGS];
export const selectorSetting = (settingId) => {
  return (state) => selectorSettings(state)[settingId];
};
